import React, { useEffect, useState } from "react";
// @mui
import { Container, List, ListItem, Paper, Typography, useTheme } from "@mui/material";
import * as XLSX from "xlsx";
import { DataGrid } from "@mui/x-data-grid";

// styled components
import FeeStructureSrc from "assets/documents/Fee structure-DPS-SHARJAH-2023-24-Najmat.xlsx";
import useResponsive from "hooks/useResponsive";
import { getDriverDetailData } from "api/busDrivers";
import { toast } from "react-toastify";

const fetchData = async (setState) => {
  try {
    const response = await fetch("");
    const blob = await response.blob();

    const reader = new FileReader();
    reader.onload = (event) => {
      const data = event.target.result;
      const workbook = XLSX.read(data, { type: "binary" });
      const sheetName = workbook.SheetNames[0]; // Assuming you want the first sheet
      const worksheet = workbook.Sheets[sheetName];
      const excelData = XLSX.utils.sheet_to_json(worksheet);
      if (excelData) {
        const FinalData = excelData.map((dataitem, index) => ({
          id: index + 1,
          ...dataitem,
        }));
        setState(FinalData);
      }
    };
    reader.readAsBinaryString(blob);
  } catch (error) {
    console.error("Error occurred while reading the file:", error);
  }
};

export const fetchDriverDetailData = async (setState) => {
  try {
    const response = await getDriverDetailData();
    if (response && response.length > 0) {
      const FinalData = response.map((dataitem, index) => ({
        id: index + 1,
        ...dataitem,
      }));
      setState(FinalData);
    }
  } catch (error) {
    console.error("Error fetching emirates:", error);
    throw error;
  }
};

const CONFIG = {
  year: "2025-2026",
};

function BusroutesTableDPSDubai({ id, white = true }) {
  const theme = useTheme();
  const [ExcelData, setExcelData] = useState([]);
  console.log("🚀 ~ BusroutesTableDPSDubai ~ ExcelData:", ExcelData);
  const [TableHeaders, setTableHeaders] = useState([]);
  const mdDown = useResponsive("down", "md");

  useEffect(() => {
    if (!ExcelData.length) {
      toast.promise(fetchDriverDetailData(setExcelData), {
        loading: "Loading data...",
        success: (data) => `FETCH SUCCESS`,
        error: "Failed to fetch data",
      });
    }

    if (ExcelData.length) {
      const keys = Object.keys(ExcelData[0]); // Extract keys from the first row of Excel data
      const filteredKeys = keys.filter((key) => key !== "id"); // Remove the 'id' key
      const finalData = filteredKeys.map((key) => ({
        headerName: key.toString().toLowerCase(),
        field: key,
        flex: key.includes("Covering") ? 4 : 1,
        display: "flex",
        flexWrap: "wrap",
        whiteSpace: "break-spaces",
        minWidth: key.length > 15 ? 220 : 80,
        sortable: false,
      }));
      setTableHeaders(finalData);
    }
  }, [ExcelData]);

  const TableColumns = [
    { field: "id", headerName: "ID", width: 90 },
    { field: "bustopnames", headerName: "Covering Area", width: 500 },
    { field: "BusNumber", headerName: "Bus Number", width: 120 },
    { field: "routename", headerName: "Area", width: 120 },
    { field: "DriverName", headerName: "Driver Name", width: 120 },
    { field: "ContactNumber", headerName: "Driver Mobile", width: 120 },
  ];

  return (
    <div style={{ background: white && theme.palette.background.paper }}>
      <Container maxWidth="xl" sx={{ py: 10 }}>
        <Typography
          variant={mdDown ? "h3" : "h1"}
          textAlign="center"
          fontWeight="700"
          fontFamily='"Merriweather", serif'
        >
          DRIVER AND BUS INFO FOR STUDENTS & STAFF {CONFIG.year}
        </Typography>

        {TableColumns && (
          <Paper
            sx={{
              mt: 5,
              "& .MuiDataGrid-cellContent": {
                whiteSpace: "break-spaces",
                padding: "8px 0px",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                textTransform: "uppercase",
                fontSize: 12,
              },
            }}
          >
            <DataGrid
              rowSelection={false}
              rows={ExcelData}
              getRowHeight={() => "auto"}
              columns={TableColumns}
              initialState={{
                pagination: {
                  paginationModel: { page: 0, pageSize: 10 },
                },
              }}
              disableColumnMenu
              hideFooterPagination={true}
            />
          </Paper>
        )}
      </Container>
    </div>
  );
}

export default BusroutesTableDPSDubai;
